module.exports = __webpack_public_path__ + "static/media/endtoendClaim.87f1e570.svg";